import { render, staticRenderFns } from "./SO_order_summary.vue?vue&type=template&id=566f6d52"
import script from "./SO_order_summary.vue?vue&type=script&lang=js"
export * from "./SO_order_summary.vue?vue&type=script&lang=js"
import style0 from "./SO_order_summary.vue?vue&type=style&index=0&id=566f6d52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports